<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">课程管理</div>
        <!--        <div slot="right" @click="delAllCourse" style="font-size: 10px;color: #ff5777;margin-right: 10px">清空所有</div>-->
        <div slot="right">
          <van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            theme="dark"
            placement="bottom-end"
            @select="onOperate"
          >
            <template #reference>
              操作
            </template>
          </van-popover>
        </div>
      </nav-bar>

      <van-cell title="添加课程" size="large" is-link to="AddCourse"/>

      <!--      <van-cell title="清空课程" @click="delAllCourse" style="color: red;text-align: center"/>-->

      <van-tabs v-model="activeWeek" @click="weeksOnChange">
        <van-tab title="周一" name="周一"></van-tab>
        <van-tab title="周二" name="周二"></van-tab>
        <van-tab title="周三" name="周三"></van-tab>
        <van-tab title="周四" name="周四"></van-tab>
        <van-tab title="周五" name="周五"></van-tab>
      </van-tabs>

      <van-tabs v-model="activeTimes" @click="timesOnChange">
        <van-tab title="一二节" name="12节"></van-tab>
        <van-tab title="三四节" name="34节"></van-tab>
        <van-tab title="五六节" name="56节"></van-tab>
        <van-tab title="七八节" name="78节"></van-tab>
      </van-tabs>
      <van-tabs v-model="campusArea" @click="timesOnChange">
        <van-tab title="南校区" name="南校区"></van-tab>
        <van-tab title="济源校区" name="济源校区"></van-tab>
      </van-tabs>
      <van-tabs v-model="activeGrade" @click="gradeOnChange" style="margin:10px 0px 10px 0px;" type="card">
        <van-tab :title="`${item}级`" :name="item" v-for="item in grades" :key="item"></van-tab>
        <van-tab title="不分年级" name="together"></van-tab>
      </van-tabs>

    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in courses" :key="item.id">
          <template slot="left">
            <van-button square type="info" @click="download(item.id,item.cname,item.week,item.times,item.tName)"
                        text="下载"/>
            <van-button square type="warning" @click="modifyCourse(item)" text="修改"/>
          </template>
          <van-cell :border="false" :label="'最大人数:'+item.maxp"
                    :title="item.cname+' 教师:'+item.tName" value="<<滑动<<"/>
          <template slot="right">
            <van-button square type="danger" @click="delCourse(item.id)" text="删除"/>
            <van-button square type="info" @click="lookStudent(item.id,item.cname)" text="人员"/>
            <van-button square type="primary" @click="lookCourse(item.id)" text="详情"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="descriptionShow" :title="this.cname+' 课程介绍'+' 当前人数:'+this.countp">
      <van-notice-bar
        left-icon="volume-o"
        :text=" '选课开始时间' + new Date(parseInt(this.startTime)).toLocaleString()"
      />
      <div style="  padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">{{ this.description }}</div>
      <van-row>
        <van-col span="24"><img style="width: 100%;padding: 40px" :src="this.img" alt=""></van-col>
      </van-row>

      <div style="padding-top: 50px"></div>
    </van-action-sheet>

    <van-action-sheet v-model="scoreImportShow" title="学生成绩导入">
      <div class="content">
        <div style="text-align: center">
          <a target="_blank"
             href="https://files.sports.hhstu.club/2023%E4%BD%93%E8%82%B2%E8%AF%BE%E5%AD%A6%E7%94%9F%E6%88%90%E7%BB%A9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx">
            <van-button style="margin-bottom: 25px" round block type="primary">学生成绩导入模板下载</van-button>
          </a>
          <van-uploader accept=".xls,.xlsx" v-model="fileList" :max-count="1" :before-read="before_read"
                        :after-read="after_read" :before-delete="delete_file">
            <van-button round block icon="plus" type="primary">学生成绩上传</van-button>
          </van-uploader>

<!--          <div v-for="(items,key,index) in repeatability" :key="index">-->
<!--            <van-divider :style="{ color: '#f40', borderColor: '#000'}">{{-->
<!--                key-->
<!--              }}项目重复学号-->
<!--            </van-divider>-->
<!--            <van-cell :border="false" v-for="(item,index) in items" :key="index" :title="item.key"-->
<!--                      :value="'重复'+item.value+'次' ">-->
<!--              <template #right-icon>-->
<!--                <van-button plain type="default" size="mini" @click="copyTextToClipboard(item.key)">复制</van-button>-->
<!--              </template>-->
<!--            </van-cell>-->
<!--          </div>-->
<!--          <div v-for="(items,key,index) in uploadCheck" :key="index">-->
<!--            <van-divider :style="{ color: '#f40', borderColor: '#000'}">{{-->
<!--                key-->
<!--              }}-->
<!--            </van-divider>-->
<!--            <van-cell :border="false" v-for="item in items" :key="item" :title="key"-->
<!--                      :value="'第'+item+'行' ">-->
<!--            </van-cell>-->
<!--          </div>-->
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import {upLoadCourseScore} from "@/network/upLoader";

import {
  getCourseList,
  DelCourseById,
  DelAllCourse,
  getCourseById,
  GetCourseScoreDownLoad
} from "../../../network/course";
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  Sticky,
  ActionSheet,
  NoticeBar,
  Row,
  Col,
  Popover,
  Uploader
} from 'vant';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Sticky);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Row);
Vue.use(Col);
Vue.use(Popover);
Vue.use(Uploader);

export default {
  name: "CourseList",
  components: {
    NavBar
  },
  data() {
    return {
      // Popover
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{text: '清空所有'}, {text: '下载全部'}, {text: '成绩导入'}],

      courses: [],


      //tab
      activeWeek: "周一",
      activeTimes: "12节",
      activeGrade: "",
      grades: [],

      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //ActionSheet
      descriptionShow: false,
      startTime: "",
      cname: "",
      description: "",
      img: "",
      countp: 0,
      campusArea:"南校区",
      // scoreImportShow
      scoreImportShow:false,
      // upload
      fileList: [],
    };
  },
  activated() {
    this.grades = this.GLOBAL.grades;
    setTimeout(() => {
      this.activeGrade = this.GLOBAL.grade;
      this.getCourseLists();
    }, 100)


  },
  // created() {
  //   this.getCourseList();
  // },
  computed: {
    getCourses() {
      let a = this.courses.filter(item => {
        return item.week == this.activeWeek && item.times == this.activeTimes;
      });
      return a;
    },
  },
  methods: {
    weeksOnChange() {
      this.getCourseLists();
    },
    timesOnChange() {
      this.getCourseLists();
    },
    gradeOnChange() {
      this.getCourseLists();
    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.courses = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.getCourseLists();
        this.isLoading = false;
      }, 1000);
    },
    // Popover
    onOperate({text}) {
      if (text == "清空所有") {
        this.delAllCourse();
        return;
      }
      if (text == "下载全部") {
        this.downloadAll();
        return;
      }
      if (text == "成绩导入") {
        this.scoreImportShow=true;
        return;
      }
    },
    getCourseLists() {
      getCourseList(this.activeGrade, this.activeWeek, this.activeTimes,this.campusArea).then(res => {
        this.courses = [];
        this.courses.push(...res);
      });
    },
    delCourse(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelCourseById(id).then(res => {
            if (res) {
              this.courses = this.courses.filter(item => item.id != id);
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    lookCourse(id) {
      let course = this.courses.filter(item => item.id === id)[0];
      getCourseById(course.id).then(res => {
        this.description = res.course.des;
        this.img = res.course.img;
        this.countp = res.countp;
      });
      this.startTime = course.starttime;
      this.cname = course.cname;

      this.descriptionShow = true;
    },
    lookStudent(id, cname) {
      this.$router.push({path: 'LookStudent', query: {courseid: id, coursename: cname, grade: this.activeGrade}})
    },
    delAllCourse() {
      Dialog.confirm({
        title: '警告',
        message: '确定要删除所有课程吗'
      }).then(() => {
        DelAllCourse().then(res => {
          if (res) {
            this.courses = [];
            Toast.success('刪除成功');
          } else {
            Toast.fail('删除失败');
          }
        }).catch(res => {
          Toast.fail('删除失败');
        })
      }).catch(() => {
      });
    },
    // 下载全部选课数据
    downloadAll() {
      let title = "全部选课数据";
      let type = 1;
      Dialog.confirm({
        title: '提示',
        message: '确定要下载' + title + '吗'
      }).then(() => {
        var a = document.createElement('a');
        a.target = "_blank";
        let hostname = document.location.hostname;
        if (hostname.indexOf("sports.hhstu.club") != -1) {
          a.href = 'http://' + hostname + "/api/download/DownLoadAllStuselect";
        } else {
          a.href = 'http://' + hostname + ":8080/api/download/DownLoadAllStuselect";
        }
        a.click();
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    onClickLeft() {
      this.$router.replace("/home");
    },
    modifyCourse(item) {
      if (!(this.$cookies.get("user") === "teacher" || this.$cookies.get("user") === "admin")) {
        Toast.fail('管理员或教师可操作');
        return
      }
      this.$router.push({path: 'ModifyCourse', query: {id: item.id}})

    },
    download(cid, cname, week, times, teacher) {
      GetCourseScoreDownLoad(cid).then(res => {
        const content = res
        const blob = new Blob([content])
        const fileName = cname + '_' + week + '_' + times + '_' + teacher + '.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch(err => {
        console.log(err);
        Dialog.alert({
          message: '下载文件出错',
        });
      })
    },
    before_read(file) {
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        Dialog.alert({
          message: '请上传 xlsx或xls 格式文件',
        });
        return false;
      } else if (file.size > 5039264) {
        Dialog.alert({
          message: '文件过大,请保持在5M以内',
        });
        return false;
      }
      return true;
    }
    ,
    after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      data.append("file", file.file);
      upLoadCourseScore(data).then(res => {
        if (res.status) {
          file.status = 'done';
          file.message = '导入成功';
          Dialog.alert({
            title: '导入成功',
            message: `导入成功或更新:${res.success},导入失败${res.fail}`,
          });
        } else {
          file.status = 'failed';
          file.message = '导入失败';
          this.repeatability = res.result;
          this.uploadCheck = res.check || [];
        }
      }).catch(res => {
        file.status = 'failed';
        file.message = '导入失败';
      })

    }
    ,
    delete_file() {
      this.FailStudentList = [];
      this.repeatability = [];
      this.uploadCheck = [];
      return true;
    }
    ,
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}

.test {
  width: 70%;
  display: flex;

  position: fixed;

  right: 0;

}
.content {
  padding: 16px 16px 160px;
}

</style>
